import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: [],
    masterData: {
        loctionList: [],
        readList: []
    },
    error: false,
    errorMessage: null,
    params: {
        "page": 0,
        "pageSize": 0,
        "sortOrder": "",
        "sortColumn": "",
        "webPageId": 0,
        "shiftUniqueId": null,
        "candidateUniqueId": "",
        "employerUniqueId": null,
        "locationId": 0,
        "fromDateRange": null,
        "toDateRange": null,
        "messageStatus": 0,
        "appMessageType": 2
    },
    totalCount: 0,
    loadingFlag: 0,
    inboxHeaderCount: 0,
    inboxHeaderData: [],
    textNotificationHeaderCount: 0,
    textNotificationHeaderData: [],
    gpsData: [],
    gpsCount: 0,
    incidentCount: localStorage.getItem('incidentCount') ? localStorage.getItem('incidentCount') : 0,
    notificationCount: 0,
    inboxMailCount: 0,
    shiftsAwaitingApprovalCount: 0,
    shiftsAwaitingPaymentCount: 0,
    shiftsAwaitingCorrectionCount:0,
    smsCount: 0,
    uploadCount: 0
}

export const notificationHeaderSlice = createSlice({
    name: 'notificationHeader',
    initialState,
    reducers: {
        setMessages: (state, action) => {
            state.data = action.payload
        },
        setError: (state, action) => {
            state.error = true;
            state.errorMessage = action.payload;
        },
        resetError: (state) => {
            state.error = false;
            state.errorMessage = null;
        },
        setTotalCount: (state, action) => {
            state.totalCount = action.payload;
        },
        setLodingFlagIncrement: (state) => {
            state.loadingFlag = state.loadingFlag + 1
        },
        setLodingFlagDecrement: (state) => {
            if (state.loadingFlag !== 0) {
                state.loadingFlag = state.loadingFlag - 1
            }
        },
        setInboxHeaderCount: (state, action) => {
            state.inboxHeaderCount = action.payload;
        },
        setInboxHeaderMessages: (state, action) => {
            state.inboxHeaderData = action.payload;
        },
        setTextNotificationHeaderCount: (state, action) => {
            state.textNotificationHeaderCount = action.payload;
        },
        setTextNotificationHeaderMessages: (state, action) => {
            state.textNotificationHeaderData = action.payload;
        },
        setGpsData: (state, { payload }) => {
            state.gpsData = payload.data;
            state.gpsCount = payload.count;
        },
        setCount: (state, { payload }) => {
            state.incidentCount = payload?.incidentCount;
            state.inboxMailCount = payload?.inboxMailCount;
            state.notificationCount = payload?.notificationCount;
            state.shiftsAwaitingApprovalCount = payload?.shiftsAwaitingApprovalCount;
            state.shiftsAwaitingPaymentCount = payload?.shiftsAwaitingPaymentCount;
            state.shiftsAwaitingCorrectionCount = payload?.shiftsAwaitingCorrectionCount;
            state.smsCount = payload?.smsCount;
            state.uploadCount = payload?.uploadCount;
        }
    }
});


export const { setMessages, setError, resetError, setTotalCount, setLodingFlagIncrement,
    setLodingFlagDecrement, setInboxHeaderCount, setInboxHeaderMessages, setTextNotificationHeaderCount,
    setTextNotificationHeaderMessages, setGpsData, setCount } = notificationHeaderSlice.actions;

export default notificationHeaderSlice.reducer;